<div class="main-content">
    <section class="top-content">
        <div class="top-contents-text">
            <div class="back-link font-inter" (click)="goBack()">← Back to Home</div>
            <h1 class="page-title font-poppins">About Us</h1>
            <p class="page-subtitle font-poppins">Inspiring creativity, curiosity, and learning through play</p>
        </div>
    </section>

    <section class="bottom-content">
        <div class="story-content">
            <!-- LEFT IMAGE -->
            <div class="story-left">
                <img src="assets/aboutus.svg" alt="Our Story" />
            </div>

            <!-- RIGHT CONTENT -->
            <div class="story-right">
                <h2 class="story-title font-poppins">Our Story</h2>

                <div class="story-item">
                    <div class="light">
                        <mat-icon svgIcon="light" class="story-icon"></mat-icon>
                    </div>
                    <div class="story-text">
                        <h4 class="font-poppins">The Beginning</h4>
                        <p class="font-inter">
                            FunFigz was born from a simple observation: Indian children deserve toys that do more than
                            entertain - they should inspire, educate, and nurture creativity.
                        </p>
                    </div>
                </div>

                <div class="story-item">
                    <div class="heart">
                        <mat-icon svgIcon="heart" class="story-icon"></mat-icon>
                    </div>
                    <div class="story-text">
                        <h4 class="font-poppins">Our Vision</h4>
                        <p class="font-inter">
                            We blend play with learning, creating experiences that help children develop critical
                            thinking, creativity, and problem-solving skills while having fun.
                        </p>
                    </div>
                </div>

                <div class="story-item">
                    <div class="crowd">
                        <mat-icon svgIcon="crowd" class="story-icon"></mat-icon>
                    </div>
                    <div class="story-text">
                        <h4 class="font-poppins">Made for India</h4>
                        <p class="font-inter">
                            Understanding the unique needs of Indian families, we curate products that align with modern
                            learning approaches while respecting cultural values and affordability.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="mission-values">
            <div class="mission-header">
                <h2 class="font-poppins">Our Mission & Values</h2>
                <p class="font-inter">
                    We're committed to making quality creative toys accessible to every Indian child, fostering a
                    generation of innovative thinkers and problem solvers.
                </p>
            </div>

            <div class="mission-grid">
                <div class="mission-card">
                    <div class="light">
                        <mat-icon svgIcon="colorplate"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Creativity First</h4>
                    <p class="font-inter">
                        Every toy we curate is designed to unlock imagination and encourage creative expression in
                        children.
                    </p>
                </div>

                <div class="mission-card">
                    <div class="heart">
                        <mat-icon svgIcon="shield"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Quality & Safety</h4>
                    <p class="font-inter">
                        All products are rigorously tested for safety standards, ensuring peace of mind for parents.
                    </p>
                </div>

                <div class="mission-card">
                    <div class="crowd">
                        <mat-icon svgIcon="gradutaion"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Learning Through Play</h4>
                    <p class="font-inter">
                        We believe the best learning happens when children are engaged, curious, and having fun.
                    </p>
                </div>

                <div class="mission-card">
                    <div class="heart">
                        <mat-icon svgIcon="handshake"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Trust & Transparency</h4>
                    <p class="font-inter">
                        We build lasting relationships with families through honest communication and reliable service.
                    </p>
                </div>
            </div>
        </div>

        <div class="choose-funfigz">
            <div class="choose-header">
                <h2 class="font-poppins">Why Choose FunFigz?</h2>
                <p class="font-inter">
                    We're more than just a toy store—we're your partner in nurturing creative, confident, and curious
                    children.
                </p>
            </div>

            <div class="choose-grid">
                <!-- CARD 1 -->
                <div class="choose-card blue">
                    <div class="icon-circle">
                        <mat-icon svgIcon="questionmark"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Curated Creative Toys</h4>
                    <p class="font-inter">
                        Handpicked selection of toys that inspire imagination and skill development.
                    </p>
                </div>
                <!-- CARD 2 -->
                <div class="choose-card red">
                    <div class="icon-circle">
                        <mat-icon svgIcon="circle"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Child-Safe Products</h4>
                    <p class="font-inter">Every item is quality-tested and certified safe for children of all ages.</p>
                </div>
                <!-- CARD 3 -->
                <div class="choose-card green">
                    <div class="icon-circle">
                        <mat-icon svgIcon="pointer"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Designed for India</h4>
                    <p class="font-inter">Products tailored to Indian households, culture, and learning needs.</p>
                </div>
                <!-- CARD 4 -->
                <div class="choose-card red">
                    <div class="icon-circle">
                        <mat-icon svgIcon="deliver"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Fast Delivery</h4>
                    <p class="font-inter">Quick and reliable shipping across India to get toys to your doorstep.</p>
                </div>
                <!-- CARD 5 -->
                <div class="choose-card green">
                    <div class="icon-circle">
                        <mat-icon svgIcon="star"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Trusted by Parents</h4>
                    <p class="font-inter">Thousands of happy families trust FunFigz for quality and reliability.</p>
                </div>
                <!-- CARD 6 -->
                <div class="choose-card blue">
                    <div class="icon-circle">
                        <mat-icon svgIcon="teacher"></mat-icon>
                    </div>
                    <h4 class="font-poppins">Educator Approved</h4>
                    <p class="font-inter">Recommended by teachers and child development experts.</p>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Our Promise to Parents & Kids section  -->
<div class="custom-blocks-section font-inter">
    <div class="image-container">
        <img src="assets/images/block3.png" class="custom-blocks-image" alt="Colorful toy blocks" />
        <div class="overlay"></div>
    </div>

    <div class="section-contianer container">
        <div class="section-content">
            <p class="section-title font-poppins">Our Promise to Parents & Kids</p>
            <p class="section-subtitle font-inter">
                At FunFigz, we're committed to delivering exceptional quality, honest pricing, and secure shopping
                experiences. We continuously innovate to bring you the best creative toys that make learning fun and
                meaningful.
            </p>
            <div class="promise-points">
                <div class="promise-item">
                    <mat-icon>check_circle</mat-icon>
                    <span>Quality Guaranteed</span>
                </div>

                <div class="promise-item">
                    <mat-icon>check_circle</mat-icon>
                    <span>Honest Pricing</span>
                </div>

                <div class="promise-item">
                    <mat-icon>check_circle</mat-icon>
                    <span>Secure Shopping</span>
                </div>
            </div>

            <div class="button-container">
                <button mat-stroked-button class="start-design-btn" (click)="navigateToProducts()">
                    Explore Our Products
                </button>
                <button mat-stroked-button class="customize-btn" (click)="navigateToContact()">ContactUs</button>
            </div>
        </div>
    </div>
</div>
